/* istanbul ignore file */
import React, { useContext, useEffect, useState } from 'react';
import App from '../App';
import UserContext from './UserContext';
import axios from 'axios';
import AuthContext from '../authentication/AuthContext';

export default function UserWrapper() {
    let cas = useContext(AuthContext);

    let [userDetails, setUserDetails] = useState({});

    useEffect(() => {
        axios
            .get(window.CONFIG['ws.activoc-web-order-api.user.details'], {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                let json = response.data;
                let currentFranchise = json.franchises.filter(
                    franchise => franchise.defaultFranchise === true
                )[0];
                setUserDetails({
                    currentFranchise: currentFranchise,
                    allFranchises: json.franchises,
                    telesales: json.telesales
                });
                // Let GTM know about current franchise
                const dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'franchiseSelection',
                    currentFranchise: currentFranchise?.code
                });
            });
    }, [cas]);

    let updateCurrentFranchise = newFranchise => {
        // Let GTM know about current franchise
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'franchiseSelection',
            currentFranchise: newFranchise.code
        });
        setUserDetails({
            ...userDetails,
            currentFranchise: newFranchise
        });
    };

    return (
        <UserContext.Provider
            value={{ userDetails: userDetails, updateCurrentFranchise: updateCurrentFranchise }}
        >
            <App />
        </UserContext.Provider>
    );
}
